import { stripPanelTrueFromBrowserUrl } from '@utils/stripPanelSearchParam';
export const SESSION_STORAGE_OPEN_USER_PANEL_KEY = 'openUserPanelAfterAuth';
export const setOpenUserPanelAfterAuth = (): void => {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(SESSION_STORAGE_OPEN_USER_PANEL_KEY, 'true');
};
export const consumeOpenUserPanelAfterAuth = (): boolean => {
  if (typeof window === 'undefined') return false;
  const shouldOpen = sessionStorage.getItem(SESSION_STORAGE_OPEN_USER_PANEL_KEY) === 'true';
  if (shouldOpen) {
    sessionStorage.removeItem(SESSION_STORAGE_OPEN_USER_PANEL_KEY);
  }
  return shouldOpen;
};

/**
 * Stare linki / callbacki z `?panel=true` powodują błąd Next (SSG + query w componentDidMount).
 * Zamieniamy param na flagę w sessionStorage i czyścimy URL przed hydracją routera.
 */
export const migratePanelTrueQueryToSessionFlag = (): void => {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  if (params.get('panel') !== 'true') return;
  setOpenUserPanelAfterAuth();
  stripPanelTrueFromBrowserUrl();
};